import BusinessOutlined from '@mui/icons-material/BusinessOutlined';
import DashboardOutlined from '@mui/icons-material/DashboardOutlined';
import DeleteOutline from '@mui/icons-material/DeleteOutline';
import GroupOutlined from '@mui/icons-material/GroupOutlined';
import PersonSearchOutlined from '@mui/icons-material/PersonSearchOutlined';
import type { SvgIconComponent } from '@mui/icons-material';

export interface NavItem {
  label: string;
  to: string;
  icon: SvgIconComponent;
  /** Highlight only on an exact match (for "/"). */
  end?: boolean;
}

export const NAV_ITEMS: NavItem[] = [
  { label: 'Dashboard', to: '/', icon: DashboardOutlined, end: true },
  { label: 'Leads', to: '/leads', icon: PersonSearchOutlined, end: true },
  { label: 'Companies', to: '/companies', icon: BusinessOutlined },
  { label: 'Users', to: '/users', icon: GroupOutlined },
  { label: 'Trash', to: '/leads/trash', icon: DeleteOutline },
];
